import { render, staticRenderFns } from "./transcript-sentiment-gauge.vue?vue&type=template&id=8fe981b0&scoped=true&"
import script from "./transcript-sentiment-gauge.vue?vue&type=script&lang=js&"
export * from "./transcript-sentiment-gauge.vue?vue&type=script&lang=js&"
import style0 from "./transcript-sentiment-gauge.vue?vue&type=style&index=0&id=8fe981b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe981b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fe981b0')) {
      api.createRecord('8fe981b0', component.options)
    } else {
      api.reload('8fe981b0', component.options)
    }
    module.hot.accept("./transcript-sentiment-gauge.vue?vue&type=template&id=8fe981b0&scoped=true&", function () {
      api.rerender('8fe981b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-sentiment-gauge/transcript-sentiment-gauge.vue"
export default component.exports